import { createContext, useContext, useState } from "react";
import { IntlProvider } from "react-intl";
import en_dictionary from "utils/lang/en.json";
import ru_dictionary from "utils/lang/ru.json";
import fr_dictionary from "utils/lang/fr.json";
import { getInitialLanguage } from "./utils";

const useIntlProviderContext = () => {
  const initialLanguage = getInitialLanguage();
  const [locale, setLocale] = useState(initialLanguage);

  const messages = {
    en: en_dictionary,
    ru: ru_dictionary,
    fr: fr_dictionary,
  };

  return {
    locale,
    setLocale,
    messages,
  };
};

const IntlProviderContext = createContext(
  {} as ReturnType<typeof useIntlProviderContext>
);

export const useIntlContext = () => useContext(IntlProviderContext);

export const CustomIntlContextProvider = ({ children }) => {
  return (
    <IntlProviderContext.Provider value={useIntlProviderContext()}>
      {children}
    </IntlProviderContext.Provider>
  );
};

export const IntlContextProvider = ({ children }) => {
  const { messages, locale } = useIntlContext();

  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      {children}
    </IntlProvider>
  );
};
